module.exports = __webpack_public_path__ + "static/media/cw.7dbea206.svg";